import React, { FunctionComponent } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import styled from "styled-components";
import { AccountState, OnlineShopperState } from "store/types/state";

const TRANSLATION_KEY = "UserAccount.TermsAndPrivacy.Links";

interface Props {
    accountSlug: AccountState["slug"];
    env: OnlineShopperState["env"];
}

export const Link = styled("a")`
    color: ${(props) => props.theme.palette.grey[60]};
    text-decoration: underline;
`;

export const getEnvString = (env: OnlineShopperState["env"]) => (env !== "prod" ? `${env}.` : ``);

const TermsAndPrivacyLinks: FunctionComponent<Props & WithTranslation> = ({ accountSlug, env, t }) => {
    const privacyLink = `https://${getEnvString(env)}onlineshopper.dealerinspire.com/legal/${accountSlug}/privacy`;
    const termsLink = `https://${getEnvString(env)}onlineshopper.dealerinspire.com/legal/${accountSlug}/terms`;

    return (
        <span>
            <Link href={termsLink} target="_blank">
                {t(`${TRANSLATION_KEY}.termsOfUse`)}
            </Link>{" "}
            {t(`${TRANSLATION_KEY}.and`)}{" "}
            <Link href={privacyLink} target="_blank">
                {t(`${TRANSLATION_KEY}.privacyStatement`)}
            </Link>
        </span>
    );
};

export default withTranslation()(TermsAndPrivacyLinks);
